import React from "react";
import Button from "@mui/material/Button";

const Loading = () => {
  return (
    <>
      <div className="loadingComponent">
        <Button loading size="large"></Button>
      </div>
    </>
  );
};

export default Loading;
